import React from "react";
import {cs} from "@common/react/chain-services";
import {DialogService} from "../../../../common/dialog/dialog-service";
import "./error-data-source-dialog.scss";

export const ErrorDataSourceDialog = ({next: rootNext}) =>
    cs(
        [
            "modal",
            ({}, next) =>
                DialogService({
                    render: ({resolve, reject, args: {content}}) => ({
                        title: "Error Data Source!",
                        content: next({reject, resolve, content}),
                    }),
                    next: rootNext,
                }),
        ],
        ({modal}) => (
            <div className="error-data-source-dialog-8er">
                <div>
                    <i className="fa fa-exclamation" />
                    <div className="text">{modal.content}</div>
                </div>
            </div>
        )
    );
